import { motion } from 'framer-motion';

const benefits = [
  {
    image: '/assets/benefits/estomago.webp',
    title: 'Mejor digestión',
    description: 'Los ingredientes frescos y mínimamente procesados son más fáciles de digerir. Muchos perros y gatos con problemas digestivos mejoran notablemente al cambiar a una dieta natural bien formulada. Heces más pequeñas, menos gases y mejor absorción de nutrientes.',
  },
  {
    image: '/assets/benefits/energia.webp',
    title: 'Más energía y vitalidad',
    description: 'Una alimentación basada en proteína de calidad y grasas saludables aporta energía estable durante todo el día. Notarás a tu mascota más activa, con ganas de jugar y pasear, sin los picos de energía que provocan los alimentos ultraprocesados.',
  },
  {
    image: '/assets/benefits/piel.webp',
    title: 'Piel y pelo más sanos',
    description: 'Los ácidos grasos esenciales presentes en carnes y pescados nutren la piel desde dentro. El resultado: menos picores, menos caspa, pelo más brillante y una barrera cutánea más fuerte frente a alergias y problemas dermatológicos.',
  },
  {
    image: '/assets/benefits/seguridad.webp',
    title: 'Sistema inmune reforzado',
    description: 'Una dieta equilibrada con nutrientes biodisponibles fortalece las defensas naturales. Menos visitas al veterinario por problemas menores, mejor recuperación tras enfermedades y mayor resistencia frente a infecciones.',
  },
  {
    image: '/assets/benefits/reloj.webp',
    title: 'Envejecimiento activo',
    description: 'La nutrición adecuada en cada etapa de la vida es clave para mantener la movilidad, la agudeza mental y la calidad de vida en perros y gatos senior. Una dieta adaptada puede ralentizar el deterioro asociado a la edad.',
  },
  {
    image: '/assets/benefits/bienestar.webp',
    title: 'Mayor bienestar general',
    description: 'Un animal bien alimentado es un animal más equilibrado: mejor humor, menos ansiedad, mejor descanso. La conexión entre nutrición y comportamiento está cada vez más documentada. Tu mascota no solo vivirá mejor, también será más feliz.',
  },
];

export const BenefitsSection = () => {
  return (
    <section className="py-20 md:py-28" data-testid="benefits-section">
      <div className="section-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <h2 className="font-manrope text-3xl md:text-4xl lg:text-5xl font-bold text-text-primary tracking-tight mb-6 section-title">
            Beneficios de una alimentación natural bien planteada
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group cursor-pointer"
              data-testid={`benefit-${index}`}
            >
              <div className="flex gap-4 bg-white rounded-2xl p-4 shadow-sm border border-gray-100
                            transition-all duration-300 ease-out
                            hover:border-[#3D6B4F] hover:shadow-lg hover:shadow-[#3D6B4F]/10
                            active:bg-[#3D6B4F] active:border-[#3D6B4F]
                            group-hover:scale-[1.02]">
                <div className="w-14 h-14 rounded-full overflow-hidden bg-[#EDF2EA] p-2 flex-shrink-0
                              transition-all duration-300 group-hover:bg-[#E8C84B]/20 group-active:bg-white/20">
                  <img 
                    src={benefit.image} 
                    alt={benefit.title}
                    loading="lazy"
                    decoding="async"
                    className="w-full h-full object-contain"
                  />
                </div>
                <div>
                  <h3 className="font-manrope font-bold text-text-primary mb-1
                               transition-colors duration-300 group-hover:text-[#3D6B4F] group-active:text-white">
                    {benefit.title}
                  </h3>
                  <p className="text-text-secondary text-sm transition-colors duration-300 group-active:text-white/80">
                    {benefit.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.6 }}
          className="mt-12 p-6 bg-brand-sage/20 rounded-2xl max-w-3xl mx-auto"
        >
          <p className="text-text-secondary text-sm text-center italic">
            Los resultados dependen de cada animal y su contexto. Por eso personalizamos y hacemos seguimiento.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default BenefitsSection;
